<template>
<div class="chapter">
<div class="inner_page">
<section epub:type="titlepage">
<p class="imaget"><a id="page_3"><img alt="image" src="images/tp.jpg" style="width:70%;"/></a></p><a id="page_3">
<p class="stitle"><em>• The Complete Collection ·</em></p>
<p class="stitle1"><span class="small">POEMS BY</span></p>
<p class="aut">William Trowbridge</p>
<p class="aut1">art by</p>
<p class="aut2">TIM MAYER</p>
<p class="pub"><img alt="image" src="images/tp1.jpg"/></p>
</a></section><a id="page_3">
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 02_Title.vue?347a427f